import Header from "./Layout/Header";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import moment from "moment";
import axios from "axios";
import { dataUser } from "./Helpers/util";
import { WALLET_POINT_AUTHORIZATION } from "../constant";
import { MultiSelect } from 'react-multi-select-component';
import axiosInstance from '../utils/axiosInstance';
import Sidebar from "./Layout/Sidebar";
import { Layout } from "antd";
import CustomHeader from "./Layout/Header";
import dayjs from "dayjs";
import AntDDatePicker from "./Common/AntDDateTimePicker/AntDDatePicker";
import SwMultiSelect from "./Common/SwMultiSelect/SwMultiSelect";
import SwButton from "./Common/SwButtons/SwButtons";
import AntDTable from "./Common/AntDTable/AntDTable";



const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function CompanyPointCrReport({ }) {
    const today = dayjs();
    const threeMonthsAgoStart = today.subtract(3, 'month').startOf('month');

    const [companyPointData, setCompanyPointData] = useState([]);
    const [filteredCompanyPointData, setFilteredCompanyPointData] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [startDate, setStartDate] = useState(today.startOf('month'));
    const [endDate, setEndDate] = useState(today);
    const [appliedStartDate, setAppliedStartDate] = useState(today.startOf('month'));
    const [appliedEndDate, setAppliedEndDate] = useState(today);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortColumn, setSortColumn] = useState(null);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [location, setLocation] = useState([]);
    const [totalPoints, setTotalPoints] = useState(0);


    const [collapsed, setCollapsed] = useState(true);
    const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
    };

   const getLedgerReportData = async () => {
    setSpinner(true);

    try {
        const res = await axiosInstance.post(
            `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/transactions/getCompanyPointsCredit/${appliedStartDate.format('DD-MM-YYYY')}/${appliedEndDate.format('DD-MM-YYYY')}/${UserObj ? UserObj.company_id : null}`,
            {}
        );

        if (res.data.message === "Data Found") {
            setCompanyPointData(res.data.transactions);
        } else {
            setCompanyPointData([]);
            setFilteredCompanyPointData([]);
        }
    } catch (error) {
        setCompanyPointData([]);
        setFilteredCompanyPointData([]);
    } finally {
        setSpinner(false);
    }
};

    const disabledStartDate = current =>
        current && (current.isBefore(threeMonthsAgoStart, 'day') || current.isAfter(today, 'day'));

    const disabledEndDate = current => {
        if (!current) return false;
        if (current.isBefore(threeMonthsAgoStart, 'day') || current.isAfter(today, 'day')) return true;
        if (startDate) {
            if (current.isBefore(startDate, 'day')) return true;
            if (current.month() !== startDate.month() || current.year() !== startDate.year()) return true;
        }
        return false;
    };

    const handleApply = () => {
        if (!startDate || !endDate) return;
        if (startDate.isSame(appliedStartDate, 'day') && endDate.isSame(appliedEndDate, 'day')) {
            getLedgerReportData();
            return;
        }
        setAppliedStartDate(startDate);
        setAppliedEndDate(endDate);
    };


    const fetchLocations = async () => {
        try {
            const authToken = JSON.parse(localStorage.getItem('headData'))?.spintlyToken;
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
                {
                    params: { spoc: UserObj.rec_id, client: UserObj.company_id },
                    headers: { Authorization: authToken }
                }
            );
            if (res.data.status === 'success') {
                setLocation(res.data.data);
            }
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };

    useEffect(() => {
        fetchLocations();
    }, []);

    useEffect(() => {
        getLedgerReportData();

    }, [appliedStartDate, appliedEndDate]);


    const handleLocationChange = selected => {
        setSelectedLocations(selected);
    };

    // Filter by date range + location
    useEffect(() => {
        const startStr = appliedStartDate.format('YYYY-MM-DD');
        const endStr = appliedEndDate.format('YYYY-MM-DD');
        let filteredData = companyPointData.filter(item => {
            const d = moment(item['Date']).format('YYYY-MM-DD');
            return d >= startStr && d <= endStr;
        });

        if (selectedLocations.length > 0) {
            const selectedLocationCodes = selectedLocations.map(loc => loc.value);
            filteredData = filteredData.filter(item =>
                selectedLocationCodes.includes(item.Location)
            );
        }
        const totalPoints = filteredData.reduce((acc, item) => acc + item.Points, 0);
        setTotalPoints(totalPoints);

        setFilteredCompanyPointData(filteredData);
    }, [appliedStartDate, appliedEndDate, selectedLocations, companyPointData]);

    // Function to handle sorting
    const handleSort = (columnName) => {
        const sortedData = [...filteredCompanyPointData].sort((a, b) => {
            if (sortDirection === 'asc') {
                return a[columnName] > b[columnName] ? 1 : -1;
            } else {
                return a[columnName] < b[columnName] ? 1 : -1;
            }
        });

        setFilteredCompanyPointData(sortedData);
        setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        setSortColumn(columnName);
    };

    const handleSortByAmount = () => {
        handleSort('Amount');
    };

    const handleExport = () => {
        const formattedData = filteredCompanyPointData?.map(item => ({
            Date: moment(item['Date']).format('DD-MM-YYYY HH:mm:ss'),
            "Name": item['Name'],
            "Email": item['Email'],
            "Location": item['Location'],
            "Points": item['Points'],
            "Expiry Date": item['Expiry Date'],
            "Credit Type": item['Credit Type'],
            // "Plan Type": item['Plan Type'],

        }));

        const headers = [
            { label: 'Date', key: 'Date' },
            { label: 'Name', key: 'Name' },
            { label: 'Email', key: 'Email' },
            { label: 'Location', key: 'Location' },
            { label: 'Points', key: 'Points' },
            { label: 'Expiry Date', key: 'Expiry Date' },
            { label: 'Credit Type', key: 'Credit Type' },
            // { label: 'Plan Type', key: 'Plan Type' },
        ];

        return { data: formattedData, headers, filename: 'DistributionReport.csv' };
    };

    const columns = [
        {
            title: "Date",
            dataIndex: "Date",
            key: "Date",
            sorter: true,
            render: (date) =>
                moment(date).format("DD-MM-YYYY HH:mm:ss"),
        },
        {
            title: "Name",
            dataIndex: "Name",
            key: "Name",
            sorter: true,
        },
        {
            title: "Email",
            dataIndex: "Email",
            key: "Email",
            sorter: true,
        },
        {
            title: "Location",
            dataIndex: "Location",
            key: "Location",
            sorter: true,
        },
        {
            title: "Points",
            dataIndex: "Points",
            key: "Points",
            sorter: true,
            noWrap: true,
        },
        {
            title: "Expiry Date",
            dataIndex: "Expiry Date",
            key: "Expiry Date",
            sorter: true,
            noWrap: true,
            minWidth: 130,
        },
        {
            title: "Credit Info",
            dataIndex: "Credit Type",
            key: "Credit Type",
            sorter: true,
            noWrap: true,
        },
    ];


    return (
        <>
            <Layout>

                <Sidebar collapsed={collapsed} />

                <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />


                <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>

                    <div className="PageContent">
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className='SwHeading'>
                                    <h2>Distribution Report</h2>
                                </div>

                                <div className="row mb-2 align-items-end g-3">
                                    <div className="col-md-2">
                                        <div className="SwFormGroup mb-0">
                                            <label className="SwFormLabel">Start Date</label>
                                            <AntDDatePicker
                                                format="DD-MM-YYYY"
                                                placeholder="Start date"
                                                value={startDate}
                                                disabledDate={disabledStartDate}
                                                onChange={date => {
                                                    if (!date) return;
                                                    setStartDate(date);
                                                    if (endDate && (endDate.isBefore(date, 'day') || endDate.month() !== date.month() || endDate.year() !== date.year())) {
                                                        setEndDate(date);
                                                    }
                                                }}
                                                allowClear={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="SwFormGroup mb-0">
                                            <label className="SwFormLabel">End Date</label>
                                            <AntDDatePicker
                                                format="DD-MM-YYYY"
                                                placeholder="End date"
                                                value={endDate}
                                                disabledDate={disabledEndDate}
                                                onChange={date => setEndDate(date)}
                                                allowClear={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="SwFormGroup mb-0">
                                            <label className='SwFormLabel'>Select Location</label>
                                            <SwMultiSelect
                                                options={location.map(loc => ({
                                                    label: loc.location_name,
                                                    value: loc.location_short_code,
                                                }))}
                                                value={selectedLocations}
                                                onChange={handleLocationChange}
                                                placeholder="Select Locations"
                                                labelledBy="Select Locations"
                                                valueRenderer={(selected, options) => {
                                                    if (selected.length === 0) return "Select Locations";
                                                    if (selected.length === options.length)
                                                        return "All locations selected";
                                                    return `${selected.length} location${selected.length > 1 ? "s" : ""} selected`;
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-auto">
                                        <div className="SwFormGroup mb-0">
                                            <label className="SwFormLabel invisible">Apply</label>
                                            <SwButton
                                                type="button"
                                                variant="primary"
                                                size="sm"
                                                onClick={handleApply}
                                                disabled={!startDate || !endDate}
                                            >
                                                Apply
                                            </SwButton>
                                        </div>
                                    </div>
                                    <div className="col-md-auto ms-auto">
                                        <div className="DistributionReportBTN">
                                            <div className="total-points">
                                                <label className="SwFormLabel">Total Points:</label>
                                                <div className="TotalPoints_Value">
                                                    <img src='./img/balance-icon-60x60.svg' alt="" />
                                                    <span>{totalPoints}</span>
                                                </div>
                                            </div>

                                            <div>
                                                {filteredCompanyPointData.length > 0 ?
                                                    <CSVLink {...handleExport()}>
                                                        <SwButton variant="dark" size="sm"
                                                            icon={<i class="bi bi-box-arrow-right"></i>}
                                                            iconPosition='start'>
                                                            Export
                                                        </SwButton>
                                                    </CSVLink> :
                                                    <SwButton disabled variant="dark" size="sm"   >
                                                        Loading Export
                                                    </SwButton>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="mt-2">
                                            
                                                <AntDTable
                                                    columns={columns}
                                                    dataSource={filteredCompanyPointData || []}
                                                    rowKey={(record, index) => index}
                                                    loading={spinner}
                                                    pagination
                                                    size="small"
                                                    pageSize={25}
                                                    clientSideSorting={true}
                                                    scroll={{ x: 1000 }}
                                                />

                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>

            </Layout>
        </>
    );
}

export default connect()(CompanyPointCrReport);
